import { PrimaryButton, SecondaryButton } from "@common/Buttons";
import { Form, Input, Switch } from "antd";
import { useEffect, useState } from "react";

export default function UserForm({
  isEdit,
  details,
  onSave,
  onCancel,
  loading,
  resetTrigger,
}) {
  const [form] = Form.useForm();
  const [isActive, setIsActive] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  //handle save
  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        if (isEdit) {
          onSave({ ...values, id: details.key, isActive, isAdmin }, isEdit);
        } else {
          onSave({ ...values }, isEdit);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //load site, grid, location options on package change
  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        firstName: details.user.firstName,
        lastName: details.user.lastName,
        email: details.user.email,
      });
      setIsActive(details.user.isActive);
      setIsAdmin(details.user.isAdmin);
    } else {
      form.setFieldsValue({
        firstName: "",
        lastName: "",
        email: "",
      });
    }
  }, [isEdit, details]);

  //reseting when data is saved or form is canceled
  useEffect(() => {
    form.resetFields();
    setIsActive(false);
    setIsAdmin(false);
  }, [resetTrigger]);

  return (
    <div className="animate-fadeIn">
      <Form form={form} layout="vertical" className="" requiredMark={false}>
        <div className="!grid !grid-cols-1 !gap-2.5">
          {/* First Name */}
          <Form.Item
            label={
              <span className="text-xs font-medium text-[#101828]">
                First Name
              </span>
            }
            className="!mb-0"
            name="firstName"
            rules={[{ required: true, message: "Please enter first name" }]}
          >
            <Input
              placeholder="Enter first name"
              className="!rounded-lg border-[#D0D5DD] !text-xs !h-8"
            />
          </Form.Item>

          {/* Last Name */}
          <Form.Item
            label={
              <span className="text-xs font-medium text-[#101828]">
                Last Name
              </span>
            }
            className="!mb-0"
            name="lastName"
            rules={[{ required: true, message: "Please enter last name" }]}
          >
            <Input
              placeholder="Enter last name"
              className="!rounded-lg border-[#D0D5DD] !text-xs !h-8"
            />
          </Form.Item>

          {/* Email */}
          <Form.Item
            label={
              <span className="text-xs font-medium text-[#101828]">Email</span>
            }
            className="!mb-0"
            name="email"
            rules={[{ required: true, message: "Please enter email" }]}
          >
            <Input
              placeholder="Enter email"
              className="!rounded-lg border-[#D0D5DD] !text-xs !h-8"
            />
          </Form.Item>

          {isEdit ? (
            <Form.Item
              label={
                <span className="text-xs font-medium text-[#101828]">
                  Is Admin
                </span>
              }
              className="!mb-0"
            >
              <Switch
                checked={isAdmin}
                onChange={(val) =>
                  isAdmin ? setIsAdmin(false) : setIsAdmin(true)
                }
                className={
                  isAdmin ? "[&_.ant-switch-inner]:!bg-primary-tint" : ""
                }
              />
            </Form.Item>
          ) : null}

          {/* is active */}
          {isEdit ? (
            <Form.Item
              label={
                <span className="text-xs font-medium text-[#101828]">
                  Is Active
                </span>
              }
              className="!mb-0"
            >
              <Switch
                checked={isActive}
                onChange={(val) =>
                  isActive ? setIsActive(false) : setIsActive(true)
                }
                className={
                  isActive ? "[&_.ant-switch-inner]:!bg-primary-tint" : ""
                }
              />
            </Form.Item>
          ) : null}
        </div>

        {/* Actions */}
        <div className="flex justify-end w-full gap-2 mt-5">
          <SecondaryButton onClick={onCancel}>
            <span className="text-xs font-medium">Cancel</span>
          </SecondaryButton>
          <PrimaryButton loading={loading} onClick={handleSave}>
            <span className="text-xs font-medium">
              {isEdit ? "Update" : "Create"}
            </span>
          </PrimaryButton>
        </div>
      </Form>
    </div>
  );
}
